// Marquee ([data-marquee] with a [data-marquee-track] around one list and a [data-marquee-toggle] button):
// copies the list until the copies cover the window, then CSS moves the track by one list width in a loop.
// The copies are hidden from screen readers. Hover and the toggle button pause it (WCAG 2.2.2); with reduced
// motion nothing moves and the list stays a still, scrollable row.
const SPEED = 40 // px per second

export function initMarquees() {
	const reduce = window.matchMedia('(prefers-reduced-motion: reduce)')
	document.querySelectorAll('[data-marquee]').forEach((marquee) => setupMarquee(marquee, reduce))
}

function setupMarquee(marquee, reduce) {
	const track = marquee.querySelector('[data-marquee-track]')
	const list = track?.querySelector('ul')
	const toggle = marquee.querySelector('[data-marquee-toggle]')
	const label = toggle?.querySelector('[data-marquee-label]')
	if (!track || !list) return

	let frame
	let width = window.innerWidth

	const fill = () => {
		track.querySelectorAll('[data-marquee-copy]').forEach((copy) => copy.remove())
		marquee.classList.remove('is-running')
		if (toggle) toggle.hidden = true
		if (reduce.matches) return

		marquee.classList.add('is-running')
		const gap = parseFloat(getComputedStyle(track).columnGap) || 0
		const distance = list.getBoundingClientRect().width + gap
		// logos still loading have no width yet: try again when they arrive
		if (distance <= gap + 1) {
			marquee.classList.remove('is-running')
			return
		}

		const copies = Math.ceil(window.innerWidth / distance) + 1
		for (let i = 0; i < copies; i++) {
			const copy = list.cloneNode(true)
			copy.setAttribute('aria-hidden', 'true')
			copy.removeAttribute('aria-label')
			copy.setAttribute('data-marquee-copy', '')
			copy.inert = true
			copy.querySelectorAll('img').forEach((img) => {
				img.alt = ''
				img.loading = 'eager'
			})
			track.append(copy)
		}
		track.style.setProperty('--marquee-distance', `${distance}px`)
		track.style.setProperty('--marquee-duration', `${distance / SPEED}s`)
		if (toggle) toggle.hidden = false
	}

	const refill = () => {
		cancelAnimationFrame(frame)
		frame = requestAnimationFrame(fill)
	}

	toggle?.addEventListener('click', () => {
		// the label says what the button does next, so no aria-pressed
		const paused = marquee.classList.toggle('is-paused')
		if (label) label.textContent = paused ? toggle.dataset.labelPlay : toggle.dataset.labelPause
	})

	list.addEventListener('load', refill, true)
	// only a new width matters (phones fire resize when the address bar shows or hides)
	window.addEventListener('resize', () => {
		if (window.innerWidth === width) return
		width = window.innerWidth
		refill()
	})
	reduce.addEventListener('change', refill)
	fill()
}
